import { render } from "./SavePayCurrency.vue?vue&type=template&id=d275743a"
import script from "./SavePayCurrency.vue?vue&type=script&lang=js"
export * from "./SavePayCurrency.vue?vue&type=script&lang=js"

import exportComponent from "/var/webapps/orangehrm/app/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__